// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// normalize CSS across browsers
// import "./src/css/normalize.css"

// custom CSS styles
// import "./src/css/style.css"
import './src/styles/global.css'

import React from "react"

export {wrapRootElement} from "./src/wrap-with-provider"

export const onClientEntry = () => {
	if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
		window.history.scrollRestoration = "manual"
	}
}

export const shouldUpdateScroll = ({ routerProps }) => {
	if (routerProps?.location?.hash) {
		return true
	}

	return false
}

export const onRouteUpdate = ({ location }) => {
	if (location?.hash) return

	window.requestAnimationFrame(() => {
		window.scrollTo(0, 0)
	})
}
